import { dayjsUtils } from '@shared/utils/helpers/dayjs';
import type {
  TAnnouncement,
  TAnnouncementStatus,
} from '@src/shared/types/announcement';

export function normalizeAnnouncementStatus(
  status?: string | null
): TAnnouncementStatus | null {
  if (!status) return null;
  const normalized = status.trim().toUpperCase();
  if (
    normalized === 'LIVE' ||
    normalized === 'SCHEDULED' ||
    normalized === 'INACTIVE' ||
    normalized === 'EXPIRED'
  ) {
    return normalized;
  }
  return null;
}

export function isFutureShareAt(shareAt?: string | null): boolean {
  if (!shareAt) return false;
  return dayjsUtils(shareAt).isAfter(dayjsUtils());
}

export function getStatusForToggleOn(
  shareAt?: string | null
): Extract<TAnnouncementStatus, 'LIVE' | 'SCHEDULED'> {
  return isFutureShareAt(shareAt) ? 'SCHEDULED' : 'LIVE';
}

export function resolveAnnouncementStatus(
  announcement: Pick<
    TAnnouncement,
    'status' | 'is_active' | 'share_at' | 'expire_at'
  >
): TAnnouncementStatus {
  const fromApi = normalizeAnnouncementStatus(announcement.status);
  if (fromApi) return fromApi;

  if (
    announcement.expire_at &&
    dayjsUtils(announcement.expire_at).isBefore(dayjsUtils())
  ) {
    return 'EXPIRED';
  }
  if (!announcement.is_active) return 'INACTIVE';
  if (isFutureShareAt(announcement.share_at)) return 'SCHEDULED';
  return 'LIVE';
}

export function isAnnouncementToggleOn(
  announcement: Pick<TAnnouncement, 'status' | 'is_active'>
): boolean {
  const status = normalizeAnnouncementStatus(announcement.status);
  if (status) {
    return status === 'LIVE' || status === 'SCHEDULED';
  }
  return announcement.is_active;
}
